import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { modules } from '../data/content';
export function ModulesSection() {
  return <section aria-labelledby="modulos" className="bg-mist" data-id="element-109" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-110" data-mp="1dwqjj0cg7g5z">
        <Reveal data-id="element-111" data-mp="1dudts10g81id">
          <SectionHeading id="modulos" title="Qué encontrarás dentro" data-id="element-112" data-mp="2bk8nlxv5zu3n" />
        </Reveal>

        <ol className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-113" data-mp="2bhw9xwwfw5we">
          {modules.map((mod, i) => <Reveal key={mod.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-navy/10 border-t-4 border-t-solar bg-white p-3" data-id="element-114" data-mp="21m2sbz3v5m7r" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-condensed text-base uppercase leading-tight tracking-wide text-navy sm:text-lg" data-id="element-115" data-mp="q7yughu5ndxf">
                <CheckCircle2Icon size={16} className="mt-1 flex-shrink-0 text-azure" strokeWidth={2.5} data-id="element-116" data-mp="l9xfa7zunyr8" />
                {mod.title}
              </h3>
              <p className="mt-1 font-body text-[0.76rem] leading-snug text-steel sm:text-[0.8rem]" data-id="element-117" data-mp="18x2orfdiymz3">
                {mod.desc}
              </p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}